<div class="loader" [ngClass]="{'complete': data && !loading}">
    <fui-ellipsis-loader></fui-ellipsis-loader>
</div>
<div class="header" *ngIf="title || ((addRowActions.length || editGridCommandComponent) && !gridReadOnly) || (hideableColumns.length && showHeader)">
    <div class="header-main">
        <div class="header-main-label" *ngIf="title">
            <div class="header-main-label-title">
                {{title | translate}}
            </div>
        </div>
        <div class="header-main-controls">
            <div class="header-main-controls-commands" *ngIf="(addRowActions.length || editGridCommandComponent) && !gridReadOnly">
                <fui-commands *ngIf="addRowSearchActions.length" [title]="'wbo.edit.grid.add.addExisting'">
                    <fui-command (clicked$)="command(action)" *ngFor="let action of addRowSearchActions"
                                 [title]="action.title" [disabled]="!action.available"></fui-command>
                </fui-commands>
                <fui-commands *ngIf="addRowNewEntityActions.length" [title]="'wbo.edit.grid.add.addNewEntity'">
                    <fui-command (clicked$)="command(action)" *ngFor="let action of addRowNewEntityActions"
                                 [title]="action.title" [disabled]="!action.available"></fui-command>
                </fui-commands>
                <fui-commands *ngIf="addRowNewActions.length" [title]="'wbo.edit.grid.add.addNewEntity'">
                    <fui-command (clicked$)="command(action)" *ngFor="let action of addRowNewActions"
                                 [title]="action.title" [disabled]="!action.available"></fui-command>
                </fui-commands>
                <fui-commands *ngIf="addRowCustomActions.length"
                              [title]="addRowCustomActions.length > 1 ? 'wbo.edit.grid.add.addCustom' : addRowCustomActions[0].title">
                    <fui-command (clicked$)="command(action)" *ngFor="let action of addRowCustomActions"
                                 [title]="action.title" [disabled]="!action.available"></fui-command>
                </fui-commands>
                <ng-content select="wbo-edit-grid-command"></ng-content>
            </div>
            <div class="header-main-controls-column-selector" *ngIf="hideableColumns.length && showHeader">
                <fui-header-form-context>
                    <wbo-more-select-control valueField="column" labelField="title"
                                             [data]="hideableColumns"
                                             [value]="enabledColumns"
                                             (valueChange)="enabledColumnsChanged($event)"
                                             [icon]="'add-column'" [iconSize]="20"
                                             [placeholder]="'wbo.edit.grid.columns'"></wbo-more-select-control>
                </fui-header-form-context>
            </div>
        </div>
    </div>
    <div class="header-message">
        <ng-content select="wbo-edit-grid-message"></ng-content>
    </div>
</div>
<wbo-edit-collection-validation *ngIf="formCollectionControl" [validationFormControl]="$any(formCollectionControl)"
                                [data]="data" [entityPath]="entityPath"></wbo-edit-collection-validation>
<div class="table" (window:resize)="onGridResize()" [ngClass]="{'force-scroll': forceScroll}">
    <kendo-grid class="table-grid" [ngClass]="{'no-header': !showHeader}"
                [data]="gridDataView"
                [scrollable]="scrollable ? 'scrollable' : 'none'"
                [pageable]="gridPageable"
                [height]="height"
                [pageSize]="pageSize"
                [skip]="gridPageableSkip"
                [sortable]="sortable"
                (pageChange)="pageChange($event)"
                (cellClick)="cellClickHandler($event)"
                (keydown)="keydownHandler($event)"
                [rowClass]="rowClassCallback">
        <kendo-grid-command-column *ngIf="!visibleColumns.length"></kendo-grid-command-column>
        <kendo-grid-command-column *ngIf="reorderable && !gridReadOnly"
                                   media="(min-width: 770px)"
                                   [style]="{
                                       'min-width.px': '34',
                                       'max-width.px': '34',
                                       'width.px': '34',
                                       'padding-left.px': '0',
                                       'padding-right.px': '0',
                                       'padding-top.px': '2',
                                       'padding-bottom.px': '0'
                                   }"
                                   [headerStyle]="{
                                       'min-width.px': '34',
                                       'max-width.px': '34',
                                       'width.px': '34',
                                       'padding-left.px': '0',
                                       'padding-right.px': '0',
                                       'padding-top.px': '2',
                                       'padding-bottom.px': '0'
                                   }">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <wbo-edit-grid-reorder-drag-drop [editGridUuid]="this.uuid"
                                                 [rowIndex]="rowIndex"
                                                 [dataItem]="dataItem"
                                                 (reordering)="onReordering($event)"
                                                 (droppedOther)="onDroppedOther($event)"></wbo-edit-grid-reorder-drag-drop>
            </ng-template>
        </kendo-grid-command-column>
        <kendo-grid-command-column *ngIf="reorderable && !gridReadOnly" media="(max-width: 769px)"
                                   [style]="{
                                       'min-width.px': '42',
                                       'max-width.px': '42',
                                       'width.px': '42',
                                       'padding-left.px': '4',
                                       'padding-right.px': '0',
                                       'padding-top.px': '2',
                                       'padding-bottom.px': '0'
                                   }">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <wbo-edit-grid-reorder-buttons [rowIndex]="rowIndex"
                                               (reordering)="onReordering($event)"></wbo-edit-grid-reorder-buttons>
            </ng-template>
        </kendo-grid-command-column>
        <kendo-grid-command-column *ngIf="selectable && (multiSelect || singleSelectStyle === SingleSelectStyle.RADIO)"
                                   [style]="{
                                       'min-width.px': '34',
                                       'max-width.px': '34',
                                       'width.px': '34',
                                       'text-align': 'center',
                                       'padding-left.px': '7',
                                       'padding-right.px': '0',
                                       'padding-top.px': '4',
                                       'padding-bottom.px': '4'
                                   }"
                                   [headerStyle]="{
                                       'min-width.px': '34',
                                       'max-width.px': '34',
                                       'width.px': '34',
                                       'text-align': 'center',
                                       'padding-left.px': '7',
                                       'padding-right.px': '0',
                                       'padding-top.px': '4',
                                       'padding-bottom.px': '4'
                                   }">
            <ng-template kendoGridHeaderTemplate>
                <fui-inline-action-form-context *ngIf="multiSelect">
                    <fui-checkbox-control [value]="allSelected"
                                          (valueChange)="toggleSelectAll($event)"></fui-checkbox-control>
                </fui-inline-action-form-context>
            </ng-template>
            <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem>
                <fui-inline-action-form-context>
                    <fui-radio-control *ngIf="!multiSelect"
                                       [ngModelOptions]="{standalone: true}"
                                       [(ngModel)]="selectedRowIndex"
                                       [equivalent]="rowIndex"
                                       (click)="confirmEditing()"
                                       [name]="radioName"></fui-radio-control>
                    <fui-checkbox-control *ngIf="multiSelect" [value]="isSelected(dataItem)"></fui-checkbox-control>
                </fui-inline-action-form-context>
            </ng-template>
        </kendo-grid-command-column>
        <kendo-grid-command-column *ngIf="!gridReadOnly && ((gridFormTemplateRef && showEditAtStart) || (removable && showRemoveAtStart))"
                                   [style]="{
                                       'min-width.px': StringUtils.toString(startCommandColumnWidth),
                                       'max-width.px': StringUtils.toString(startCommandColumnWidth),
                                       'width.px': StringUtils.toString(startCommandColumnWidth),
                                       'text-align': 'center',
                                       'padding-left.px': '7',
                                       'padding-right.px': '7',
                                       'padding-top.px': '1',
                                       'padding-bottom.px': '0'
                                   }">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <fui-inline-action-form-context>
                    <fui-action *ngIf="gridFormTemplateRef && showEditAtStart"
                                (click)="editRowForm(dataItem, rowIndex, false)"
                                [attr.action-name]="'edit'"
                                [attr.title]="'wbo.common.button.edit' | translate">
                        <fui-icon [width]="18" [height]="18" [icon]="'more'"></fui-icon>
                    </fui-action>
                    <fui-action *ngIf="removable && showRemoveAtStart && rowRemovable(rowIndex, dataItem)"
                                [attr.title]="'wbo.common.button.remove' | translate" [attr.action-name]="'remove'"
                                (click)="removeRow(rowIndex, dataItem, confirmRemoval)">
                        <fui-icon [width]="18" [height]="18" [icon]="'delete'"></fui-icon>
                    </fui-action>
                </fui-inline-action-form-context>
            </ng-template>
        </kendo-grid-command-column>
        <ng-container *ngFor="let col of visibleColumns; let columnIndex = index; trackBy: trackByFn">
            <kendo-grid-column
                [title]="col.title"
                [field]="col.field"
                [width]="col.width ? col.width : col.editable && !col.restricted ? 350 : 0"
                [style]="{'min-width.px': StringUtils.toString(col.width), 'max-width.px': StringUtils.toString(col.maxWidth)}"
                [editable]="col.editable && !col.restricted && !gridReadOnly"
                [sortable]="col.sortable"
                [class]="{'editable': col.editable && !col.restricted && !gridReadOnly}">
                <!-- header template -->
                <ng-template *ngIf="col.contentChildHeaderTemplate" kendoGridHeaderTemplate
                             let-column="column">
                    <ng-template [ngTemplateOutlet]="col.contentChildHeaderTemplate"
                                 [ngTemplateOutletContext]="{'columnIndex': columnIndex, 'column': column}"></ng-template>
                </ng-template>
                <ng-template *ngIf="col.viewChildHeaderTemplate && !col.contentChildHeaderTemplate"
                             kendoGridHeaderTemplate
                             let-column="column">
                    <ng-template [ngTemplateOutlet]="col.viewChildHeaderTemplate"
                                 [ngTemplateOutletContext]="{'columnIndex': columnIndex, 'column': column}"></ng-template>
                </ng-template>
                <ng-template *ngIf="!col.contentChildHeaderTemplate && !col.viewChildHeaderTemplate"
                             kendoGridHeaderTemplate>
                    <div class="column-header" (click)="onHeaderTemplateClick($event)">
                        <div class="column-header-control" *ngIf="col.hideable">
                            <fui-mark-button class="column-header-control-button"
                                             (click)="toggleEnabled(col, $event)">
                                <fui-icon icon="close" height="8" width="8"></fui-icon>
                            </fui-mark-button>
                        </div>
                        <div class="column-header-title" [ngClass]="{'restricted': col.restricted}"
                             [innerHTML]="col.title | translate"></div>
                    </div>
                </ng-template>
                <!-- footer template -->
                <ng-template *ngIf="col.contentChildFooterTemplate" kendoGridFooterTemplate
                             let-column="column">
                    <ng-template [ngTemplateOutlet]="col.contentChildFooterTemplate"
                                 [ngTemplateOutletContext]="{'columnIndex': columnIndex, 'column': column}"></ng-template>
                </ng-template>
                <ng-template *ngIf="col.viewChildFooterTemplate && !col.contentChildFooterTemplate"
                             kendoGridFooterTemplate
                             let-column="column">
                    <ng-template [ngTemplateOutlet]="col.viewChildFooterTemplate"
                                 [ngTemplateOutletContext]="{'columnIndex': columnIndex, 'column': column}"></ng-template>
                </ng-template>
                <!-- cell Template -->
                <ng-container
                    *ngIf="col.linkable && (col.contentChildLinkTemplate || col.viewChildLinkTemplate)">
                    <ng-template *ngIf="col.contentChildLinkTemplate" kendoGridCellTemplate
                                 let-dataItem let-rowIndex="rowIndex" let-column="column">
                        <div class="error-indicator" (click)="$event['ignoreClickOutside'] = true"
                             *ngIf="columnIndex === 0 && (editable || selectable) && !gridReadOnly && !addingRow">
                        </div>
                        <ng-template [ngTemplateOutlet]="col.contentChildLinkTemplate"
                                     [ngTemplateOutletContext]="{'dataItem': dataItem, 'rowIndex': rowIndex, 'columnIndex': columnIndex, 'column': column}"></ng-template>
                    </ng-template>
                    <ng-template *ngIf="col.viewChildLinkTemplate && !col.contentChildLinkTemplate"
                                 kendoGridCellTemplate
                                 let-dataItem let-rowIndex="rowIndex" let-column="column">
                        <div class="error-indicator" (click)="$event['ignoreClickOutside'] = true"
                             *ngIf="columnIndex === 0 && (editable || selectable) && !gridReadOnly && !addingRow">
                        </div>
                        <ng-template [ngTemplateOutlet]="col.viewChildLinkTemplate"
                                     [ngTemplateOutletContext]="{'dataItem': dataItem, 'rowIndex': rowIndex, 'columnIndex': columnIndex, 'column': column}"></ng-template>
                    </ng-template>
                </ng-container>
                <ng-container
                    *ngIf="!col.linkable || (!col.contentChildLinkTemplate && !col.viewChildLinkTemplate)">
                    <ng-template *ngIf="col.contentChildCellTemplate" kendoGridCellTemplate
                                 let-dataItem let-rowIndex="rowIndex" let-column="column">
                        <div class="error-indicator" (click)="$event['ignoreClickOutside'] = true"
                             *ngIf="columnIndex === 0 && (editable || selectable) && !gridReadOnly && !addingRow">
                        </div>
                        <ng-template [ngTemplateOutlet]="col.contentChildCellTemplate"
                                     [ngTemplateOutletContext]="{'dataItem': dataItem, 'rowIndex': rowIndex, 'columnIndex': columnIndex, 'column': column}"></ng-template>
                    </ng-template>
                    <ng-template *ngIf="col.viewChildCellTemplate && !col.contentChildCellTemplate"
                                 kendoGridCellTemplate
                                 let-dataItem let-rowIndex="rowIndex" let-column="column">
                        <div class="error-indicator" (click)="$event['ignoreClickOutside'] = true"
                             *ngIf="columnIndex === 0 && (editable || selectable) && !gridReadOnly && !addingRow">
                        </div>
                        <ng-template [ngTemplateOutlet]="col.viewChildCellTemplate"
                                     [ngTemplateOutletContext]="{'dataItem': dataItem, 'rowIndex': rowIndex, 'columnIndex': columnIndex, 'column': column}"></ng-template>
                    </ng-template>
                </ng-container>
                <ng-template *ngIf="!col.viewChildLinkTemplate && !col.contentChildLinkTemplate"
                             kendoGridCellTemplate
                             let-dataItem let-rowIndex="rowIndex" let-column="column">
                    <div class="error-indicator" (click)="$event['ignoreClickOutside'] = true"
                         *ngIf="columnIndex === 0 && (editable || selectable) && !gridReadOnly && !addingRow">
                    </div>
                    <span (click)="$event['ignoreClickOutside'] = true">{{dataItem | property: col.field}}</span>
                </ng-template>
                <!-- edit template -->
                <ng-template *ngIf="col.contentChildEditTemplate" kendoGridEditTemplate
                             let-rowIndex="rowIndex" let-column="column" let-formGroup="formGroup">
                    <ng-template [ngTemplateOutlet]="col.contentChildEditTemplate"
                                 [ngTemplateOutletContext]="{'dataItem': editingRecord, 'rowIndex': rowIndex, 'columnIndex': columnIndex, 'column': column, 'formGroup': formGroup}"></ng-template>
                </ng-template>
                <ng-template *ngIf="col.viewChildEditTemplate && !col.contentChildEditTemplate"
                             kendoGridEditTemplate
                             let-rowIndex="rowIndex" let-column="column" let-formGroup="formGroup">
                    <ng-template [ngTemplateOutlet]="col.viewChildEditTemplate"
                                 [ngTemplateOutletContext]="{'dataItem': editingRecord, 'rowIndex': rowIndex, 'columnIndex': columnIndex, 'column': column, 'formGroup': formGroup}"></ng-template>
                </ng-template>
            </kendo-grid-column>
        </ng-container>
        <kendo-grid-command-column *ngIf="!gridReadOnly && ((gridFormTemplateRef && showEditAtEnd) || (removable && showRemoveAtEnd) || (localisable && localisationEnabled))"
                                   [style]="{
                                       'min-width.px': StringUtils.toString(endCommandColumnWidth),
                                       'max-width.px': StringUtils.toString(endCommandColumnWidth),
                                       'width.px': StringUtils.toString(endCommandColumnWidth),
                                       'text-align': 'center',
                                       'padding-left.px': '7',
                                       'padding-right.px': '7',
                                       'padding-top.px': '2',
                                       'padding-bottom.px': '0'
                                   }">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <fui-actions class="command-actions">
                    <fui-action (click)="editRowForm(dataItem, rowIndex, false)"
                                *ngIf="gridFormTemplateRef && showEditAtEnd" [attr.action-name]="'edit'"
                                [attr.title]="'wbo.common.button.edit' | translate">
                        <fui-icon [width]="18" [height]="18" [icon]="'more'"></fui-icon>
                    </fui-action>
                    <fui-action *ngIf="duplicatable && rowDuplicatable(rowIndex, dataItem)"
                                [attr.title]="'wbo.common.button.duplicate' | translate" [attr.action-name]="'duplicate'"
                                (click)="duplicateRow(rowIndex, dataItem, confirmRemoval)">
                        <fui-icon [width]="18" [height]="18" [icon]="'clone'"></fui-icon>
                    </fui-action>
                    <fui-action *ngIf="removable && showRemoveAtEnd && rowRemovable(rowIndex, dataItem)"
                                [attr.title]="'wbo.common.button.remove' | translate" [attr.action-name]="'remove'"
                                (click)="removeRow(rowIndex, dataItem, confirmRemoval)">
                        <fui-icon [width]="18" [height]="18" [icon]="'delete'"></fui-icon>
                    </fui-action>
                    <fui-action (click)="openLocalisationDialog(dataItem)"
                                [attr.title]="'wbo.common.button.localisation' | translate"
                                [attr.action-name]="'localisation'"
                                id="localisation-action" *ngIf="localisable && localisationEnabled"
                                [ngSwitch]="isLocalised(dataItem)">
                        <fui-icon [width]="18" [height]="18" [icon]="'globe'" *ngSwitchDefault></fui-icon>
                        <fui-icon [width]="18" [height]="18" [icon]="'globe-marker'" *ngSwitchCase="true"></fui-icon>
                    </fui-action>
                </fui-actions>
            </ng-template>
        </kendo-grid-command-column>
        <kendo-grid-command-column *ngIf="selectable && !multiSelect && singleSelectStyle === SingleSelectStyle.ARROW"
                                   [style]="{
                                       'min-width.px': '42',
                                       'max-width.px': '42',
                                       'width.px': '42',
                                       'text-align': 'center',
                                       'padding-left.px': '0',
                                       'padding-right.px': '11',
                                       'padding-top.px': '4',
                                       'padding-bottom.px': '4'
                                   }">
            <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem>
                <fui-inline-action-form-context>
                    <fui-action class="select-arrow" (click)="selectRow(rowIndex, dataItem)">
                        <fui-icon [width]="18" [height]="18" [icon]="'chevron-right'"></fui-icon>
                    </fui-action>
                </fui-inline-action-form-context>
            </ng-template>
        </kendo-grid-command-column>
        <ng-template kendoGridNoRecordsTemplate>
            <fui-empty [title]="emptyTitle" [description]="emptyDescription"></fui-empty>
        </ng-template>
        <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
            <kendo-pager-numeric-buttons [buttonCount]="4"></kendo-pager-numeric-buttons>
            <kendo-pager-info></kendo-pager-info>
        </ng-template>
    </kendo-grid>
    <ng-content select="wbo-edit-grid-add-row" *ngIf="!gridReadOnly"></ng-content>
</div>
<div class="footer">
    <ng-content select="wbo-edit-grid-footer"></ng-content>
</div>
